/**
 * File generated by js-routes 2.2.8
 * Based on Rails 6.1.7.10 routes of Sparkler::Application
 */
// eslint-disable-next-line
(
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                module.exports = routes;
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                define([], function () {
                    return routes;
                });
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (true &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (keyword_parameters.trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            result += keyword_parameters.anchor
                ? "#" + keyword_parameters.anchor
                : "";
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return false
                ? result
                : encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
        }
    }
    const Utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return Utils.route(parts_table, route_spec, absolute);
        },
    };
    const result = {
        ...__jsr,
        configure: (config) => {
            return Utils.configure(config);
        },
        config: () => {
            return Utils.config();
        },
        serialize: (object) => {
            return Utils.serialize(object);
        },
        ...{
  /**
   * Generates rails route to
   * /api/dashboard/dashboard/account(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  account_api_dashboard_dashboard_index_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/players/:player_id/player_questionnaires/age_range_for_date(.:format)
   * @param {any} player_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  age_range_for_date_api_dashboard_player_player_questionnaires_path: __jsr.r({"player_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"players"],[2,[7,"/"],[2,[3,"player_id"],[2,[7,"/"],[2,[6,"player_questionnaires"],[2,[7,"/"],[2,[6,"age_range_for_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/accounts/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_account_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/account_players/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_account_player_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"account_players"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/account_players(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_account_players_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"account_players"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/account_players_filters(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_account_players_filters_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"account_players_filters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/accounts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_accounts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/accounts/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_administration_account_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/accounts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_administration_accounts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/admin_users/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_administration_admin_user_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"admin_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/admin_users(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_administration_admin_users_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"admin_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/filters(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_administration_filters_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"filters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/organizations/cohorts/:cohort_id/pdf(.:format)
   * @param {any} cohort_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_administration_organizations_cohort_pdf_path: __jsr.r({"cohort_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"cohorts"],[2,[7,"/"],[2,[3,"cohort_id"],[2,[7,"/"],[2,[6,"pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/organizations/cohorts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_administration_organizations_cohorts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"cohorts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/organizations/cohorts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_administration_organizations_create_cohort_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"cohorts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/organizations/groups(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_administration_organizations_create_group_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/organizations/subgroups(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_administration_organizations_create_subgroup_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"subgroups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/organizations/cohorts/:cohort_id(.:format)
   * @param {any} cohort_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_administration_organizations_destroy_cohort_path: __jsr.r({"cohort_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"cohorts"],[2,[7,"/"],[2,[3,"cohort_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/organizations/groups/:group_id(.:format)
   * @param {any} group_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_administration_organizations_destroy_group_path: __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"group_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/organizations/subgroups/:subgroup_id(.:format)
   * @param {any} subgroup_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_administration_organizations_destroy_subgroup_path: __jsr.r({"subgroup_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"subgroups"],[2,[7,"/"],[2,[3,"subgroup_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/organizations/groups(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_administration_organizations_groups_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/organizations/my_accesses(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_administration_organizations_my_accesses_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"my_accesses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/organizations/search(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_administration_organizations_search_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/organizations/subgroups(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_administration_organizations_subgroups_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"subgroups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/organizations/supervisors(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_administration_organizations_supervisors_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"supervisors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/organizations/cohorts/:cohort_id(.:format)
   * @param {any} cohort_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_administration_organizations_update_cohort_path: __jsr.r({"cohort_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"cohorts"],[2,[7,"/"],[2,[3,"cohort_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/organizations/groups/:group_id(.:format)
   * @param {any} group_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_administration_organizations_update_group_path: __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"group_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/organizations/subgroups/:subgroup_id(.:format)
   * @param {any} subgroup_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_administration_organizations_update_subgroup_path: __jsr.r({"subgroup_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"subgroups"],[2,[7,"/"],[2,[3,"subgroup_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/asq_surveys/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_asq_survey_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"asq_surveys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/asq_surveys(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_asq_surveys_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"asq_surveys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/asq_surveys_filters(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_asq_surveys_filters_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"asq_surveys_filters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/authenticate(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_authenticate_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"authenticate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/authentication(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_authentication_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"authentication"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/bulk_messages(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_bulk_messages_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"bulk_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/cards/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_card_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"cards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/cards(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_cards_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"cards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/change_password(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_change_password_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"change_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/communication(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_communication_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"communication"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/communication/conversation/:player_id(.:format)
   * @param {any} player_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_communication_conversation_path: __jsr.r({"player_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"communication"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"player_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/communication/conversation/:id/message(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_communication_create_message_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"communication"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/communication/detect-language(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_communication_detect_language_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"communication"],[2,[7,"/"],[2,[6,"detect-language"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/communication/filters-for-cards(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_communication_filters_for_cards_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"communication"],[2,[7,"/"],[2,[6,"filters-for-cards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/communication/filters-for-groups(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_communication_filters_for_groups_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"communication"],[2,[7,"/"],[2,[6,"filters-for-groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/communication/filters-for-pc(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_communication_filters_for_pc_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"communication"],[2,[7,"/"],[2,[6,"filters-for-pc"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/communication/filters-for-players(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_communication_filters_for_players_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"communication"],[2,[7,"/"],[2,[6,"filters-for-players"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/communication/group-messages(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_communication_group_messages_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"communication"],[2,[7,"/"],[2,[6,"group-messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/communication/mark-all-read(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_communication_mark_all_read_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"communication"],[2,[7,"/"],[2,[6,"mark-all-read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/communication/me(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_communication_me_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"communication"],[2,[7,"/"],[2,[6,"me"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/communication/message(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_communication_send_message_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"communication"],[2,[7,"/"],[2,[6,"message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/communication/message-groups(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_communication_send_message_to_groups_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"communication"],[2,[7,"/"],[2,[6,"message-groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/communication/translate(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_communication_translate_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"communication"],[2,[7,"/"],[2,[6,"translate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/communication/unread(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_communication_unread_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"communication"],[2,[7,"/"],[2,[6,"unread"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/communication/unread-count(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_communication_unread_count_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"communication"],[2,[7,"/"],[2,[6,"unread-count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/communication/conversation/:id/update-unread-status(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_communication_update_unread_status_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"communication"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update-unread-status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/dashboard_filters(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_dashboard_filters_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"dashboard_filters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/dashboard(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_dashboard_index_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/follow_up_surveys/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_follow_up_survey_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"follow_up_surveys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/follow_up_surveys(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_follow_up_surveys_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"follow_up_surveys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/forgot_password(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_forgot_password_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"forgot_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/group_cohorts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_group_cohorts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"group_cohorts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/logout(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_logout_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/messaging_channel/:messaging_channel_id/messages/:id(.:format)
   * @param {any} messaging_channel_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_messaging_channel_message_path: __jsr.r({"messaging_channel_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"messaging_channel"],[2,[7,"/"],[2,[3,"messaging_channel_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/messaging_channel/:messaging_channel_id/messages(.:format)
   * @param {any} messaging_channel_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_messaging_channel_messages_path: __jsr.r({"messaging_channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"messaging_channel"],[2,[7,"/"],[2,[3,"messaging_channel_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/organization_type_group_cohorts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_organization_type_group_cohorts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"organization_type_group_cohorts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/partner_actions(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_partner_actions_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"partner_actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/partner_custom_tags(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_partner_custom_tags_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"partner_custom_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/players/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_player_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"players"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/players/:player_id/coach_chats(.:format)
   * @param {any} player_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_player_coach_chats_path: __jsr.r({"player_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"players"],[2,[7,"/"],[2,[3,"player_id"],[2,[7,"/"],[2,[6,"coach_chats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/players/:player_id/player_questionnaires/:id(.:format)
   * @param {any} player_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_player_player_questionnaire_path: __jsr.r({"player_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"players"],[2,[7,"/"],[2,[3,"player_id"],[2,[7,"/"],[2,[6,"player_questionnaires"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/players/:player_id/player_questionnaires/:player_questionnaire_id/answers/:id(.:format)
   * @param {any} player_id
   * @param {any} player_questionnaire_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_player_player_questionnaire_answer_path: __jsr.r({"player_id":{"r":true},"player_questionnaire_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"players"],[2,[7,"/"],[2,[3,"player_id"],[2,[7,"/"],[2,[6,"player_questionnaires"],[2,[7,"/"],[2,[3,"player_questionnaire_id"],[2,[7,"/"],[2,[6,"answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/players/:player_id/player_questionnaires/:player_questionnaire_id/answers(.:format)
   * @param {any} player_id
   * @param {any} player_questionnaire_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_player_player_questionnaire_answers_path: __jsr.r({"player_id":{"r":true},"player_questionnaire_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"players"],[2,[7,"/"],[2,[3,"player_id"],[2,[7,"/"],[2,[6,"player_questionnaires"],[2,[7,"/"],[2,[3,"player_questionnaire_id"],[2,[7,"/"],[2,[6,"answers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/players/:player_id/player_questionnaires/:player_questionnaire_id/notes/:id(.:format)
   * @param {any} player_id
   * @param {any} player_questionnaire_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_player_player_questionnaire_note_path: __jsr.r({"player_id":{"r":true},"player_questionnaire_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"players"],[2,[7,"/"],[2,[3,"player_id"],[2,[7,"/"],[2,[6,"player_questionnaires"],[2,[7,"/"],[2,[3,"player_questionnaire_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/players/:player_id/player_questionnaires/:player_questionnaire_id/notes(.:format)
   * @param {any} player_id
   * @param {any} player_questionnaire_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_player_player_questionnaire_notes_path: __jsr.r({"player_id":{"r":true},"player_questionnaire_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"players"],[2,[7,"/"],[2,[3,"player_id"],[2,[7,"/"],[2,[6,"player_questionnaires"],[2,[7,"/"],[2,[3,"player_questionnaire_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/players/:player_id/player_questionnaires/:player_questionnaire_id/sections/:section_id/complete(.:format)
   * @param {any} player_id
   * @param {any} player_questionnaire_id
   * @param {any} section_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_player_player_questionnaire_section_complete_path: __jsr.r({"player_id":{"r":true},"player_questionnaire_id":{"r":true},"section_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"players"],[2,[7,"/"],[2,[3,"player_id"],[2,[7,"/"],[2,[6,"player_questionnaires"],[2,[7,"/"],[2,[3,"player_questionnaire_id"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/players/:player_id/player_questionnaires(.:format)
   * @param {any} player_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_player_player_questionnaires_path: __jsr.r({"player_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"players"],[2,[7,"/"],[2,[3,"player_id"],[2,[7,"/"],[2,[6,"player_questionnaires"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/players/:player_id/player_questionnaires_filters(.:format)
   * @param {any} player_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_player_player_questionnaires_filters_path: __jsr.r({"player_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"players"],[2,[7,"/"],[2,[3,"player_id"],[2,[7,"/"],[2,[6,"player_questionnaires_filters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/players_filters/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_players_filter_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"players_filters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/players_filters(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_players_filters_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"players_filters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/program_content_entries(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_program_content_entries_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"program_content_entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/program_content_entries/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_program_content_entry_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"program_content_entries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/settings/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_setting_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/translations/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_translation_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"translations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/translations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_translations_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"translations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/translations_filters(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_dashboard_translations_filters_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"translations_filters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/admin_users/:id/archive_toggle(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  archive_toggle_api_dashboard_administration_admin_user_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"admin_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive_toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/dashboard/asq(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  asq_api_dashboard_dashboard_index_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"asq"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/dashboard/asq_stats(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  asq_stats_api_dashboard_dashboard_index_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"asq_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/admin_users/:id/cohort_create(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cohort_create_api_dashboard_administration_admin_user_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"admin_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cohort_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/admin_users/:id/cohort_destroy/:cohort_id(.:format)
   * @param {any} id
   * @param {any} cohort_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cohort_destroy_api_dashboard_administration_admin_user_path: __jsr.r({"id":{"r":true},"cohort_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"admin_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cohort_destroy"],[2,[7,"/"],[2,[3,"cohort_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/players/:player_id/player_questionnaires/completed(.:format)
   * @param {any} player_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  completed_api_dashboard_player_player_questionnaires_path: __jsr.r({"player_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"players"],[2,[7,"/"],[2,[3,"player_id"],[2,[7,"/"],[2,[6,"player_questionnaires"],[2,[7,"/"],[2,[6,"completed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/account_players/csv_export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  csv_export_api_dashboard_account_players_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"account_players"],[2,[7,"/"],[2,[6,"csv_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/asq_surveys/csv_export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  csv_export_api_dashboard_asq_surveys_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"asq_surveys"],[2,[7,"/"],[2,[6,"csv_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/group_cohorts/csv_export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  csv_export_api_dashboard_group_cohorts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"group_cohorts"],[2,[7,"/"],[2,[6,"csv_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/organization_type_group_cohorts/csv_export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  csv_export_api_dashboard_organization_type_group_cohorts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"organization_type_group_cohorts"],[2,[7,"/"],[2,[6,"csv_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/user_actions/csv_export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  csv_export_api_dashboard_user_actions_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"user_actions"],[2,[7,"/"],[2,[6,"csv_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/accounts/custom_ids(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  custom_ids_api_dashboard_administration_accounts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"custom_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/accounts/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_dashboard_account_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/account_players/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_dashboard_account_player_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"account_players"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/accounts/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_dashboard_administration_account_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/account_players/:id/engagement(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  engagement_api_dashboard_account_player_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"account_players"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"engagement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/dashboard/engagement(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  engagement_api_dashboard_dashboard_index_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"engagement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/bulk_messages/filters(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  filters_api_dashboard_bulk_messages_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"bulk_messages"],[2,[7,"/"],[2,[6,"filters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/group_cohorts/filters(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  filters_api_dashboard_group_cohorts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"group_cohorts"],[2,[7,"/"],[2,[6,"filters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/organization_type_group_cohorts/filters(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  filters_api_dashboard_organization_type_group_cohorts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"organization_type_group_cohorts"],[2,[7,"/"],[2,[6,"filters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/players/:player_id/coach_chats/filters(.:format)
   * @param {any} player_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  filters_api_dashboard_player_coach_chats_path: __jsr.r({"player_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"players"],[2,[7,"/"],[2,[3,"player_id"],[2,[7,"/"],[2,[6,"coach_chats"],[2,[7,"/"],[2,[6,"filters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/asq_surveys/:id/follow_up_answers_for_message(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  follow_up_answers_for_message_api_dashboard_asq_survey_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"asq_surveys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"follow_up_answers_for_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/dashboard/follow_up(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  follow_up_api_dashboard_dashboard_index_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"follow_up"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/asq_surveys/follow_up_csv_export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  follow_up_csv_export_api_dashboard_asq_surveys_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"asq_surveys"],[2,[7,"/"],[2,[6,"follow_up_csv_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/asq_surveys/:id/follow_up_parent_message_sendout(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  follow_up_parent_message_sendout_api_dashboard_asq_survey_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"asq_surveys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"follow_up_parent_message_sendout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/asq_surveys/:id/follow_up_parent_message_templates(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  follow_up_parent_message_templates_api_dashboard_asq_survey_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"asq_surveys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"follow_up_parent_message_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/account_players/:id/free_plays(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  free_plays_api_dashboard_account_player_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"account_players"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"free_plays"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/admin_users/:id/group_create(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  group_create_api_dashboard_administration_admin_user_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"admin_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"group_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/admin_users/:id/group_destroy/:group_id(.:format)
   * @param {any} id
   * @param {any} group_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  group_destroy_api_dashboard_administration_admin_user_path: __jsr.r({"id":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"admin_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"group_destroy"],[2,[7,"/"],[2,[3,"group_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/account_players/:id/interactivity(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  interactivity_api_dashboard_account_player_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"account_players"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"interactivity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/dashboard/interactivity(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  interactivity_api_dashboard_dashboard_index_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"interactivity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/settings/locale(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  locale_api_dashboard_settings_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"locale"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/accounts/:id/merge_candidates(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  merge_candidates_api_dashboard_administration_account_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"merge_candidates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/messaging_channel/:messaging_channel_id/messages/:id/message(.:format)
   * @param {any} messaging_channel_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  message_api_dashboard_messaging_channel_message_path: __jsr.r({"messaging_channel_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"messaging_channel"],[2,[7,"/"],[2,[3,"messaging_channel_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/translations/:id/message(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  message_api_dashboard_translation_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"translations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/accounts/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_dashboard_account_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/account_players/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_dashboard_account_player_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"account_players"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/accounts/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_dashboard_administration_account_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/account_players/:id/plays(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  plays_api_dashboard_account_player_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"account_players"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"plays"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/asq_surveys/:id/reminder_sendout(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reminder_sendout_api_dashboard_asq_survey_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"asq_surveys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reminder_sendout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/accounts/:id/request_delete_account(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  request_delete_account_api_dashboard_administration_account_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"request_delete_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/accounts/:id/players/:player_id/request_delete(.:format)
   * @param {any} id
   * @param {any} player_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  request_delete_player_api_dashboard_administration_account_path: __jsr.r({"id":{"r":true},"player_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"players"],[2,[7,"/"],[2,[3,"player_id"],[2,[7,"/"],[2,[6,"request_delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/accounts/:id/players/:source_player_id/request_merge(.:format)
   * @param {any} id
   * @param {any} source_player_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  request_merge_player_api_dashboard_administration_account_path: __jsr.r({"id":{"r":true},"source_player_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"players"],[2,[7,"/"],[2,[3,"source_player_id"],[2,[7,"/"],[2,[6,"request_merge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/account_players/:id/reset_cohorts(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reset_cohorts_api_dashboard_account_player_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"account_players"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset_cohorts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/accounts/:id/reset_password(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reset_password_api_dashboard_account_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/accounts/:id/reset_password(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reset_password_api_dashboard_administration_account_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/admin_users/:id/reset_password(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reset_password_api_dashboard_administration_admin_user_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"admin_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/asq_surveys/:id/results_parent_email_sendout(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  results_parent_email_sendout_api_dashboard_asq_survey_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"asq_surveys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"results_parent_email_sendout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/follow_up_surveys/:id/save_history(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  save_history_api_dashboard_follow_up_survey_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"follow_up_surveys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"save_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/filters/sponsors(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  sponsors_api_dashboard_administration_filters_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"filters"],[2,[7,"/"],[2,[6,"sponsors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/players/:player_id/player_questionnaires/:id/status(.:format)
   * @param {any} player_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  status_api_dashboard_player_player_questionnaire_path: __jsr.r({"player_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"players"],[2,[7,"/"],[2,[3,"player_id"],[2,[7,"/"],[2,[6,"player_questionnaires"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/admin_users/:id/subgroup_create(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  subgroup_create_api_dashboard_administration_admin_user_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"admin_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"subgroup_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/administration/admin_users/:id/subgroup_destroy/:subgroup_id(.:format)
   * @param {any} id
   * @param {any} subgroup_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  subgroup_destroy_api_dashboard_administration_admin_user_path: __jsr.r({"id":{"r":true},"subgroup_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"admin_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"subgroup_destroy"],[2,[7,"/"],[2,[3,"subgroup_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/asq_surveys/:id/translate_follow_up_parent_message(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  translate_follow_up_parent_message_api_dashboard_asq_survey_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"asq_surveys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"translate_follow_up_parent_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/messaging_channel/:messaging_channel_id/messages/update_read_status(.:format)
   * @param {any} messaging_channel_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_read_status_api_dashboard_messaging_channel_messages_path: __jsr.r({"messaging_channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"messaging_channel"],[2,[7,"/"],[2,[3,"messaging_channel_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"update_read_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/dashboard/players/:player_id/player_questionnaires/valid_date_range(.:format)
   * @param {any} player_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  valid_date_range_api_dashboard_player_player_questionnaires_path: __jsr.r({"player_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"players"],[2,[7,"/"],[2,[3,"player_id"],[2,[7,"/"],[2,[6,"player_questionnaires"],[2,[7,"/"],[2,[6,"valid_date_range"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]])}
,
    };
    Utils.define_module("UMD", result);
    return result;
})();

